<template>
    <div class="photo-listing-wrapper">
        <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom">
            <v-container fluid>
                <v-row v-if="title && isDesktop">
                    <v-col cols="12">
                        <section-header :title="title" :action="false" class="px-0 mb-4"></section-header>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col v-for="i in items" :key="i" cols="6" md="4">
                        <v-img :src="`https://picsum.photos/500/300?image=${i * n * 5 + 10}`" :lazy-src="`https://picsum.photos/10/6?image=${i * n * 5 + 10}`" aspect-ratio="1"></v-img>
                    </v-col>
                </v-row>
            </v-container>
        </infinite-scroller-vertical>
    </div>
</template>
<script>
export default {
    props: ['n', 'title', 'photos'],
    data: () => ({
        items: 12
    }),
    methods: {
        onReachScrollBottom(val) {
            if(val) {
                this.items += 6
            }
        }
    }
}
</script>